import React from "react";
import {Types} from "components";
import {Button} from "reactstrap";
import ObjectOverride from "components/ObjectOverride";
import APPCONFIG from "../../constants/Config";
import PropTypes from "prop-types";
import API from "@beardeddevops/react.api";

/**
 *  @property {Accounts_Customizations_Object} state
 *  @property {object} model
 *  @property {Accounts_Customizations_Properties} model.properties
 *  @property {Accounts_Customizations_Is} model.is
 *  @property {Accounts_Customizations_Has} model.has
 */
export default class DropBoxConnect extends ObjectOverride {
	static propTypes = {
		url: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
	}

	handleDropboxDisconnect = ()=> {
		//disconnect
		let dropbox = new API.BuildClass(Types.Dropbox._name, API.RequestType.DELETE);
		//remove and reload
		dropbox.submit(null, "DELETE_DROPBOX").then( () => window.location.reload());
	}

	render = () => {
		let redirect = this.props.url;
		let dropbox_url = 'https://www.dropbox.com/oauth2/authorize?token_access_type=offline&response_type=code&client_id=ahxqyp71atuamxy&redirect_uri=' + APPCONFIG.settings.apiURL() + '/v423/dropbox/dropbox&state=' + redirect;
		return (
			<div>
				<h4 className="section-title">Dropbox Integration</h4>
				<div className="form-group">
					Every night we will upload copies of your bound books to your Dropbox account
				</div>
				<div className="form-group">
					{/*show button if no refresh token, else show text that its connected and possibly how to disconnect*/}
					{this.state.dropbox_refresh_token === null ?
						<a href={dropbox_url}>
							<Button color="primary">Connect Your Dropbox Account</Button>
						</a>
						: <span>
							You have your Dropbox connected:
							<i>
								<span style={{color: 'green', marginLeft: '5px'}}>
									{this.state.dropbox_email}
								</span>
							</i>
							<br />
							<Button onClick={() => this.handleDropboxDisconnect()} style={{marginTop: '15px'}} color={"danger"}>Disconnect your Dropbox Account</Button>
						 </span>
					}
				</div>
			</div>
		)
	};

}

